import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";

import Templates from "./Templates";
import NewTemplate from "./NewTemplate";
import EditTemplate from "./EditTemplate";

class MessageTemplates extends React.Component {
  state = {
    showTemplates: false,
    showNewTemplate: false,
    dataEdit: null
  };

  render() {
    const {templates, onDelete} = this.props;

    return [
      <button
        key="button"
        type="button"
        className="btn btn-indigo btn-raised btn-long"
        onClick={this.handlerToggleList}
      >
        TEMPLATES
      </button>,
      <Templates
        key="templates-list"
        templates={templates}
        show={this.state.showTemplates}
        onClose={this.handlerToggleList}
        onShowNew={this.handlerToggleNew}
        onDelete={onDelete}
        onEdit={this.handlerToggleEdit}
      />,
      <NewTemplate
        key="new-template"
        show={this.state.showNewTemplate}
        onClose={this.handlerToggleNew}
        onAdded={this.handlerAdded}
      />,
      <EditTemplate
        key="edit-template"
        show={!!this.state.dataEdit}
        dataEdit={this.state.dataEdit}
        onClose={this.handlerToggleEdit}
        onUpdated={this.handlerUpdated}
      />
    ];
  }

  handlerToggleList = () => this.setState({showTemplates: !this.state.showTemplates});
  handlerToggleNew = () => this.setState({showNewTemplate: !this.state.showNewTemplate});

  handlerToggleEdit = (e) => {
    if (this.state.dataEdit === null) {
      const id = parseInt(e.target.getAttribute("data-id"));
      const dataEdit = lodash.find(this.props.templates, {id: id});
      this.setState({dataEdit});
    } else {
      this.setState({dataEdit: null});
    }
  };

  handlerAdded = (dataNewTemplate) => {
    this.handlerToggleNew();
    this.props.onAdded(dataNewTemplate);
  };

  handlerUpdated = (newDataTemplate) => {
    this.handlerToggleEdit();
    this.props.onUpdated(newDataTemplate);
  };
}

MessageTemplates.propTypes = {
  templates: PropTypes.array,
  onAdded: PropTypes.func,
  onDelete: PropTypes.func,
  onUpdated: PropTypes.func
};

export default MessageTemplates;
